module.exports = __webpack_public_path__ + "img/commerBanner.89f5b732.png";